module.exports = class Utils {
    
    constructor(opts={}) {}

    // This method contains Max Limit for All facets when clicked on more.
  getMaxLimitForExpansion(facetName) {
    let maxLimitForEveryFacet = {
      "objekte._nested:objekte__obj_schlagworte_lok.obj_schlagwort_lok/lokal_klass_sach": {
        limit: 40
      },
      "objekte._nested:objekte__obj_dargestellte_personen.obj_dargestellte_person.conceptName": {
        limit: 40
      },
      "objekte._nested:objekte__obj_autoren.obj_autor_gnd.conceptName": {
        limit: 40
      },
      "objekte._nested:objekte__obj_herstellungsorte.obj_herstellungsort_gnd.conceptName": {
        limit: 40
      },
      "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok/lokal_klass_person": {
        limit: 40
      },
      "objekte._nested:objekte__obj_sprachen.obj_sprache_gnd.conceptName": {
        limit: 40
      },
      "objekte.obj_sachbegriff.conceptName": {
        limit: 40
      },
      "objekte._nested:objekte__obj_autoren_lok.obj_autor_lok&&lokal_klass_person": {
        limit: 40
      }
    };
    let defaultMaxLimit = 100;
    return maxLimitForEveryFacet[facetName] ? maxLimitForEveryFacet[facetName].limit : defaultMaxLimit;
  }

}


//////////////////
// WEBPACK FOOTER
// ./js/Utils/utils.js
// module id = 8
// module chunks = 0